export class CptEditCommand{
    feeScheduleId:string;
    id:string;
    code:string;
    name:string;
    category:string;
    apcCode:string;
    baseRate:number;
    grouperPointer:string;
    multiProcedureDiscount:boolean;
    relativeWeight?: number;

    constructor(feeScheduleId:string, id:string, code:string, name:string, category:string, apcCode:string, baseRate:string, grouperPointer:string, multiProcedureDiscount:boolean, relativeWeight?:number){
        this.feeScheduleId = feeScheduleId;
        this.id = id;
        this.code = code;
        this.name = name;
        this.category = category;
        this.apcCode = apcCode;
        this.baseRate = baseRate == '' ? 0 : Number(baseRate);
        this.grouperPointer = grouperPointer ?? '0';
        this.multiProcedureDiscount = multiProcedureDiscount ?? false;
        this.relativeWeight = relativeWeight;
    }
}